import { render, staticRenderFns } from "./StreamPlayer.vue?vue&type=template&id=a1acaff8&scoped=true&"
import script from "./StreamPlayer.vue?vue&type=script&lang=js&"
export * from "./StreamPlayer.vue?vue&type=script&lang=js&"
import style0 from "./StreamPlayer.vue?vue&type=style&index=0&id=a1acaff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1acaff8",
  null
  
)

export default component.exports